import $ from 'jquery';

/**
 *
 */
export function videoUtils() {
	$('.wp-block-videos').on('click', '.item--video', function() {
		const $iframe = $(this).find('.video-embed').html();

		$(this).addClass('active').siblings('.item.active').removeClass('active');

		$(this).parents('.wp-block-videos').find('.wp-block-video').hide().html($iframe).fadeIn(1000);
	});
}
